const form = {
  formId: "new-user-form",
  formField: {
    startDate: {
      name: "startDate",
      label: "[01] Kỳ tính thuế: Từ ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    endDate: {
      name: "endDate",
      label: "Đến ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu:",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ:",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    taxPayerName: {
      name: "taxPayerName",
      label: "[04] Tên người nộp thuế:",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxPayerId: {
      name: "taxPayerId",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[06] Tên đại lý thuế (nếu có):",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[07] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentContract: {
      name: "taxAgentContract",
      label: "[08] Hợp đồng đại lý thuế: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập hợp đồng đại lý thuế: Số",
    },
    taxAgentContractDate: {
      name: "taxAgentContractDate",
      label: "Ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },
    contractorContract: {
      name: "contractorContract",
      label: "[09] Hợp đồng nhà thầu: Số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập hợp đồng nhà thầu: Số",
    },
    contractorContractDate: {
      name: "contractorContractDate",
      label: "Ngày:",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
